import DefaultList from "@Common/DefaultList";

import { useNavigationHandler } from "@hook";
import { getStatusTag, handleCopyBuffer } from "@utils";
import { inject, observer } from "mobx-react";

import moment from "moment";
import { Tag } from "primereact/tag";

const TestOffersList = inject("mainStore")(
    observer(({ mainStore }) => {
        const filter = mainStore.getMainStore("filter");

        const navigation = useNavigationHandler();

        const handleRowClick = (e) => {
            navigation(e.originalEvent, `/test-offer/${e.data._id}`);
        };

        const columns = [
            {
                field: "_id",
                header: "Id",
                sortable: false,
                style: { width: "5%" },
                type: "text",
                body: (item) => (
                    <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                        <span className=" text">ID</span>
                        <i className="pi pi-clone"></i>
                    </div>
                ),
            },
            {
                field: "title",
                body: (item) => <span className="list__name">{item.title}</span>,
                header: "Название",
                sortable: true,
                style: { maxWidth: "350px", overflow: "hidden" },
                type: "text",
            },
        ];
        const isInactive = filter?.headerSelect === "inactive";

        if (filter?.headerSelect !== "draft") {
            columns.push(
                {
                    field: "dateStart",
                    header: "Start",
                    body: (item) => <span>{item.dateStart ? moment(item.dateStart).format("DD.MM.YY") : "-"}</span>,
                    style: { width: "10%", maxWidth: "127px", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },
                {
                    field: "dateEnd",
                    header: "End",
                    body: (item) => <span>{item.dateEnd ? (moment(item.dateEnd).diff(moment(item.dateStart), "years") > 50 ? "∞" : moment(item.dateEnd).format("DD.MM.YY")) : "-"}</span>,
                    style: { width: "10%", maxWidth: "127px", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },
                {
                    field: "dateStopCampaign",
                    header: isInactive ? "Pause" : "Launch",
                    body: (item) => {
                        if (isInactive) return <span>{item.dateStopAb ? moment(item.dateStopAb).format("DD.MM.YY") : "-"}</span>;
                        return <span>{item.dateStartAb ? moment(item.dateStartAb).format("DD.MM.YY") : "-"}</span>;
                    },
                    style: { maxWidth: "50px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },
            );
        }

        if (filter?.headerSelect === "draft") {
            columns.push({
                field: "createdAt",
                header: "Created",
                body: (item) => <span>{item.createdAt ? moment(item.createdAt).format("DD.MM.YY") : "-"}</span>,
                style: { maxWidth: "30px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                sortable: true,
            });
        }

        columns.push({
            header: "Статус",
            body: (item) => {
                const tag = getStatusTag(item);
                return <Tag severity={tag.type} icon={tag.icon} className={item.__groupKey ? "companies__status-" + item.__groupKey : ""} />;
            },
            style: { width: "1%" },
            sortable: false,
        });

        return (
            <DefaultList
                dataKey={"abtset_offer"}
                apiUrl="/abtest/aboffers"
                keysToGet={["_id", "title", "active", "archived", "draft", "dateStart", "dateEnd", "dateStartAb", "dateStopAb", "createdAt"]}
                titleName="АБ тесты / Офферы"
                titleAddButton="тест"
                keyFilterSearch="title"
                handleRowClick={handleRowClick}
                checkbox={false}
                columns={columns}
            />
        );
    }),
);

export default TestOffersList;
